import { Observable } from 'rxjs';
import { PaginationModel, SpecialtyModel, VacantPositionModel } from '../../models';

export abstract class BaseVacantPositionService {

  public searchResults$: Observable<VacantPositionModel[]>;
  public filteredResults$: Observable<VacantPositionModel[]>;

  public abstract getVacantPosition(pathNid: string): Observable<VacantPositionModel>;
  public abstract getVacantPositionWorkingCopy(pathNid: string): Observable<VacantPositionModel>;
  public abstract getVacantPositions(pagination: PaginationModel, specialties: SpecialtyModel[]): Observable<VacantPositionModel[]>;
  public abstract filterResults(filters: any, positions?: VacantPositionModel[]);
  public abstract getFilterData(): Observable<{}>;
  public abstract getVacantPositionsForProgram(programs: string[]): Observable<VacantPositionModel[]>;
  public abstract deleteVacantPosition(vacantPosition: VacantPositionModel): Observable<boolean>;
  public abstract updateVacantPosition(vacantPosition: VacantPositionModel, programContactKeys?): Observable<VacantPositionModel>;
  public abstract updateProgramContact(vacantPosition: VacantPositionModel): Observable<VacantPositionModel>;
}
